import styled from "styled-components";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";

export const FormLabel = styled.label`
  font-size: ${fontSizes.regular}px;
  font-weight: 500;
  color: ${colors.text};
`;
